import './Variants.af68b7660c42f30fe0c506eda2713d48.css';
export default {"primary":"_primary_hpciu_1","error":"_error_hpciu_1","secondary":"_secondary_hpciu_1","tertiary":"_tertiary_hpciu_1","process":"_process_hpciu_1"};